import { IField, TextTypeVariants, ValidationTypes } from '@eventr/common'
import {
    SelectInputField,
    TextInputField,
    useValidatorContext,
} from '@eventr/common-storybook'
import { useEffect, useMemo, useState } from 'react'

import i18n from '../../../i18n/i18next'
import { useEditSectionContext } from '../editSectionProvider'
import { editItineraryFieldsTranslation } from '../../../i18n/translateHelpers'
interface ITextInputFieldProps {
    field: IField
    _id?: string
}

export const TextEditField = ({ field, _id }: ITextInputFieldProps) => {
    const { getValue, updateValues } = useEditSectionContext()
    const { isFieldValid, removeFieldState } = useValidatorContext()

    const [state, setState] = useState<string>()
    const [isError, setIsError] = useState<boolean>(false)
    const [textError, setTextError] = useState<string>('')

    useEffect(() => {
        const initFieldValue = getValue(field, _id)

        if (
            typeof initFieldValue !== 'string' &&
            initFieldValue !== null &&
            typeof initFieldValue !== 'number'
        ) {
            setState(JSON.stringify(initFieldValue))
        } else {
            setState(initFieldValue ?? '')
        }
    }, [field, _id, getValue])

    useEffect(() => {
        const valid = isFieldValid(field, _id, state)
        if ((valid !== true) !== isError) {
            setIsError(valid !== true)
        }
        if (valid !== true) {
            setTextError(valid as string)
        } else {
            setTextError('')
        }
    }, [state, field, _id, isFieldValid, setIsError, isError, setTextError])

    const cleanUp = () => {
        if (_id) {
            removeFieldState(field, _id)
        }
    }

    useEffect(() => {
        return () => {
            cleanUp()
        }
    }, [])

    const isRequired = useMemo(() => {
        return field.type_properties?.validations?.some(
            (v) => v.type === ValidationTypes.required
        )
    }, [field.type_properties?.validations])

    if (field.type_properties?.variant == TextTypeVariants.textArea) {
        return (
            <div>
                <TextInputField
                    id={field.field_name}
                    value={state}
                    error={isError}
                    errorMessage={textError}
                    onChange={(v) => {
                        setState(v.currentTarget.value)
                        updateValues({
                            value: v.currentTarget.value,
                            field: field,
                            _id: _id,
                        })
                    }}
                    fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
                    required={isRequired}
                    multiline
                    rows={2}
                />
            </div>
        )
    }

    if (
        field.type_properties?.data_source_properties &&
        field.type_properties.data_source_properties.options
    ) {
        return (
            <div>
                <SelectInputField
                    defaultValue={state}
                    required={isRequired}
                    fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
                    error={isError}
                    errorMessage={textError}
                    data={field.type_properties.data_source_properties.options.map(
                        (option) => {
                            return {
                                displayName:
                                    editItineraryFieldsTranslation(option),
                                id: option,
                            }
                        }
                    )}
                    onChange={(v) => {
                        setState(v.target.value as string)
                        updateValues({
                            value: v.target.value,
                            field: field,
                            _id: _id,
                        })
                    }}
                />
            </div>
        )
    }

    return (
        <div>
            <TextInputField
                id={field.field_name}
                value={state}
                error={isError}
                errorMessage={textError}
                onChange={(v) => {
                    setState(v.currentTarget.value)
                    updateValues({
                        value: v.currentTarget.value,
                        field: field,
                        _id: _id,
                    })
                }}
                fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`)}
                required={isRequired}
            />
        </div>
    )
}
